<template>
    <div class="footer">
      <div class="auto">
          <div class="copyRight">
              <p> 本支付平台由大智慧信息科技有限公司提供<a href="http://www.gw.com.cn/download/fx.html"  target="_blank">风险提示</a></p>
              <p>Copyright &copy; 2012 www.gw.com.cn 版权所有 大智慧信息科技有限公司
                <router-link :to="'/term'">使用条款</router-link>
                <router-link :to="'/privacy'">客户隐私政策</router-link>
              </p>
          </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/AppFooter.vue